import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { Store } from "@ngrx/store";
import { AppState } from "src/app/store/state/app.state";
import { pluck } from "rxjs/operators";
import { NzModalService } from "ng-zorro-antd/modal";
import { Dictionary } from "src/app/store/models/common_types";
import { AlertSettingsPageDataService } from "../alert-settings-page-data.service";
import { alertTypeEnum } from "../alert-settings-page.model";
import { TickerSearchComponent } from "src/app/shared/ticker-search/ticker-search.component";
import { WatchlistDropdownComponent } from "src/app/shared/watchlist-dropdown/watchlist-dropdown.component";
import {
  VAIconRegistryService,
  bell,
  chevronRight,
} from "@va/core-library/icons";
import { faBell } from "@fortawesome/pro-light-svg-icons";
@Component({
  selector: "app-set-alert-modal",
  templateUrl: "./set-alert-modal.component.html",
  styleUrls: ["./set-alert-modal.component.scss"],
})
export class SetAlertModalComponent implements OnChanges {
  @Input() showAlertsModal: boolean;
  @Input() alertType: alertTypeEnum;
  @Input() title: string;
  @Output() onCancel: EventEmitter<any> = new EventEmitter();
  @Output() onOk: EventEmitter<any> = new EventEmitter();
  @ViewChild(TickerSearchComponent)
  tickerSearchComp: TickerSearchComponent;
  @ViewChild(WatchlistDropdownComponent)
  watchlistDropdownComponent: WatchlistDropdownComponent;
  alertsParams: Dictionary<any>;
  okBtnText = "Set";
  alertTypeEnum = alertTypeEnum;
  userId: string;
  watchlistData;
  selectedWatchlist;
  faBell = faBell;
  titles = {
    company: "Set Company Alert",
    watchlist: "Set Watchlist Alert",
  };

  constructor(
    private modalService: NzModalService,
    private dataService: AlertSettingsPageDataService,
    private store: Store<AppState>,
    private iconRegistry: VAIconRegistryService,
  ) {
    store
      .select("globalHeader")
      .pipe(pluck("globalSettings"))
      .subscribe((data: any) => {
        if (data && data.userId) {
          this.userId = data.userId;
        }
      });
    this.iconRegistry.registerIcons([bell, chevronRight]);
  }
  ngOnChanges(changes: SimpleChanges) {
    if (
      changes.alertType &&
      changes.alertType.currentValue !== changes.alertType.previousValue
    ) {
      this.alertType = changes.alertType.currentValue;
      this.title = this.titles[changes.alertType.currentValue];
    }
  }

  onWatchlistChange(selectedOption) {
    if (selectedOption) {
      this.alertsParams = {
        key: selectedOption,
        type: "watchlist",
      };
    } else {
      this.alertsParams = null;
    }
  }

  resetAlertsComp() {
    this.alertsParams = null;
    this.tickerSearchComp && this.tickerSearchComp.changeValue(null);
    this.watchlistDropdownComponent &&
      this.watchlistDropdownComponent.changeValue(null);
  }
  onModalCancel() {
    this.onCancel.emit();
    this.resetAlertsComp();
  }
  onModalOk() {
    this.onOk.emit();
    this.resetAlertsComp();
  }

  addSearchedTicker(selectedOption) {
    if (selectedOption && selectedOption.ticker) {
      this.alertsParams = {
        key: selectedOption.ticker,
        type: "company",
      };
    } else {
      this.alertsParams = null;
    }
  }
}
